import React from 'react';
import { connect } from 'react-redux';

import { getStravaActivity } from 'reducers/selectors';

const StravaCard = ({ activity }) => {
    const distanceMiles = (activity.distance / 1609.34).toFixed(2);
    const timeMinutes = Math.floor(activity.moving_time / 60);
    const dateFormatted = new Date(
        activity.start_date_local
    ).toLocaleDateString(undefined, {
        month: 'short',
        day: 'numeric',
        year: 'numeric',
    });

    return (
        <div className="max-w-xs p-4 rounded-xl border border-gray-200 bg-white shadow-sm font-sans">
            <div className="flex items-center justify-between mb-2">
                <span className="text-xs font-semibold uppercase tracking-wide text-orange-600">
                    {activity.type}
                </span>
                <span className="text-xs text-gray-400">{dateFormatted}</span>
            </div>

            <h3 className="text-base font-bold text-gray-900 mb-3 truncate">
                {activity.name}
            </h3>

            <div className="grid grid-cols-3 gap-2 pt-2 border-t border-gray-100 text-center">
                <div>
                    <p className="text-xs text-gray-500">Distance</p>
                    <p className="text-sm font-semibold text-gray-800">
                        {distanceMiles} mi
                    </p>
                </div>
                <div>
                    <p className="text-xs text-gray-500">Time</p>
                    <p className="text-sm font-semibold text-gray-800">
                        {timeMinutes} m
                    </p>
                </div>
                <div>
                    <p className="text-xs text-gray-500">Elev Gain</p>
                    <p className="text-sm font-semibold text-gray-800">
                        {Math.round(activity.total_elevation_gain * 3.28084)} ft
                    </p>
                </div>
            </div>
        </div>
    );
};

export default connect(state => {
    return {
        activity: getStravaActivity(state),
    };
}, null)(StravaCard);
